// extracted by mini-css-extract-plugin
module.exports = {"filter":"ClustersQueuedChart_filter__21WYm"};